import React from 'react';
import { Modal, Button } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';

type PreventExportModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const PreventExportModal = ({ isOpen, onClose }: PreventExportModalProps) => {
    const { translate } = useTranslate();

    return (
        <Modal
            container={modalContainer}
            title={translate('design.sidebar.shots.modal.overset.title')}
            isOpen={isOpen}
            onClose={onClose}
            actionPrimary={
                <Button variant="primary" onClick={onClose}>
                    {translate('design.sidebar.shots.modal.overset.button')}
                </Button>
            }
        >
            {translate('design.sidebar.shots.modal.overset.content')}
        </Modal>
    );
};

export default PreventExportModal;
